// Class EventLogger
var _callAddThis = true;
var _commIdHD = 0;
var _builderIdHD = 0;
var _marketIdCR = 0;
// Constructor, it receives a json object with parameters
NHS.Scripts.Globals.EventLogger = function (logParameters) {
    this._siteRoot = logParameters.siteRoot;
    this._partnerId = logParameters.partnerID;
    this._marketId = logParameters.marketId;
    this._fromPage = logParameters.fromPage;
    this._communityId = logParameters.communityId;
    this._builderId = logParameters.builderId;
    this._planId = logParameters.planId;
    this._specId = logParameters.specId;
    this._homeSearchViewMetricDisplayed = logParameters.homeSearchViewMetricDisplayed;
    this._homeSearchViewMetricHidden = logParameters.homeSearchViewMetricHidden;
    this._partnerName = logParameters.partnerName;
    this._marketName = logParameters.marketName;
    this._communityName = logParameters.communityName;
    this._builderName = logParameters.builderName;
    this._performanceLogUrl = logParameters.performanceLogUrl;
    this._mpcCommunityId = logParameters.isMpcCommunity === true ? logParameters.parentCommunityId : 0;
    this._parentCommunityId = logParameters.parentCommunityId;
    this._eventLoggerUrl = "eventlogger/logevent-";
    this._timeOut = 2000;
};

NHS.Scripts.Globals.EventLogger.prototype =
    {
        // Public Members
        logListHubEvent: function (listHubProviderId, testkey, desckey, listingKey) {
            try {
                var _lh = new ListHubTracker({ provider: listHubProviderId, test: testkey });
                _lh.submit(desckey, listingKey);
            } catch (err) { }
        },

        logAndRedirect: function (e, url, eventCode, cid, bid, pid, sid, mid, external) {
            this._marketId = mid;
            this.logEvent(eventCode, cid, bid, pid, sid);
            this._redirect(e, url, external);
            return false;
        },

        logBasicListingAndRedirect: function (e, url, eventCode, bsid, mid) {
            var self = this;

            setTimeout(function () {
                var params = { basiclistingId: bsid, marketId: mid };
                self.logEventWithParameters(eventCode, params);
                self._redirect(e, url);
                return false;
            }, self._timeOut);
        },

        logWithParametersAndRedirect: function (e, url, eventCode, params, external) {
            var self = this;

            setTimeout(function () {
                self.logEventWithParameters(eventCode, params);
                self._redirect(e, url, external);
                return false;
            }, self._timeOut);
        },

        logEventWithParameters: function (eventCode, parameters) {
            var self = this;

            setTimeout(function () {
                if (eventCode) {
                    var url = self._siteRoot + self._eventLoggerUrl + eventCode;

                    if (self._siteRoot.substring(self._siteRoot.length - 1) != "/") {
                        url = "/" + url;
                    }

                    self._logViewWithParameters(url, eventCode, parameters);
                }
            }, self._timeOut);
        },

        logEventWithoutEcommerce: function (eventCode, parameters) {
            var self = this;

            setTimeout(function () {
                if (eventCode) {
                    var url = self._siteRoot + self._eventLoggerUrl + eventCode;

                    if (self._siteRoot.substring(self._siteRoot.length - 1) != "/") {
                        url = "/" + url;
                    }

                    self._logViewWithoutEcommerce(url, eventCode, parameters);
                }
            }, self._timeOut);
        },

        logBasicListingEvent: function (eventCode, bsid) {
            if (eventCode) {
                var url = this._siteRoot + this._eventLoggerUrl + eventCode;

                if (this._siteRoot.substring(this._siteRoot.length - 1) != "/") {
                    url = "/" + url;
                }

                this._logView(url, eventCode, 0, 0, 0, 0, bsid);
            }
        },

        logEvent: function (eventCode, cid, bid, pid, sid) {
            if (eventCode) {
                var url = this._siteRoot + this._eventLoggerUrl + eventCode;

                if (this._siteRoot.substring(this._siteRoot.length - 1) != "/") {
                    url = "/" + url;
                }

                this._logView(url, eventCode, cid, bid, pid, sid, 0);
            }
        },

        setAllowAddThis: function () {
            _callAddThis = false;
            setTimeout(function () {
                _callAddThis = true;
            }, 2000);
        },

        logMultiEvent: function (eventCode, communityId, builderId, planId, specId) {
            if (eventCode) {
                var url = this._siteRoot + this._eventLoggerUrl + eventCode;

                if (this._siteRoot.substring(this._siteRoot.length - 1) != "/") {
                    url = "/" + url;
                }

                this._logView(url, eventCode, communityId, builderId, planId, specId, 0);
            }
        },

        logHomeResultsMetrics: function (eventCode, flag) {

            if (eventCode) {
                var logString;

                if (flag == 1) {
                    logString = this._homeSearchViewMetricDisplayed;
                }
                else {
                    logString = this._homeSearchViewMetricHidden;

                }


                this._logMetrics(eventCode, logString);
            }
        },

        attachEventsToAddThis: function () {
            var self = this;

            if (typeof addthis != 'undefined') {
                addthis.addEventListener('addthis.menu.share', function (evt) {
                    if (_callAddThis) {
                        var serviceShared = evt.data.service.toString().toLowerCase();
                        var eventCode = 'MHSMS';
                        var hdPage = self._planId > 0 || self._specId > 0;

                        if (serviceShared.indexOf('favorites') == -1 && serviceShared.indexOf('print') == -1 && serviceShared.indexOf('email') == -1) {
                            if (self._planId == 0 && self._specId == 0 && self._communityId == 0) {
                                eventCode = 'MHSMS';
                            } else {
                                hdPage = self._planId > 0 || self._specId > 0;
                                eventCode = hdPage ? 'HDSMS' : 'CDSMS';
                            }
                            self.logMultiEvent(eventCode, self._communityId, self._builderId, self._planId, self._specId);
                        }
                        else if (serviceShared.indexOf('email') > -1) {
                            hdPage = self._planId > 0 || self._specId > 0;
                            eventCode = hdPage ? 'HOMSTF' : 'COMSTF';
                            self.logMultiEvent(eventCode, self._communityId, self._builderId, self._planId, self._specId);
                            self.setAllowAddThis();
                        } else if (serviceShared.indexOf('print') > -1) {
                            hdPage = self._planId > 0 || self._specId > 0;
                            eventCode = hdPage ? 'HOMPR' : 'COMPR';

                            if (jQuery(this).hasClass('nextStepsPrint')) {
                                eventCode = hdPage ? 'HDNSPRN' : 'CDNSPRN';
                            }

                            var logInfo = self.getLogInfo();

                            self.logEventWithParameters(eventCode, logInfo);
                            self.setAllowAddThis();
                        }
                    }
                });
            }
        },

        getLogInfo: function () {
            var logInformationObject;
            var logInfo =
            {
                    communityId: self._communityId,
                    builderId: self._builderId,
                    planId: self._planId,
                    specId: self._specId
            };
            if (typeof commDetail != "undefined") {
                logInformationObject = commDetail._parameters || commDetail.parameters;
                logInfo = logInformationObject.logInfo;
            }
            else if (typeof homeDetail != "undefined") {
                logInformationObject = homeDetail._parameters || homeDetail.parameters;
                logInfo = logInformationObject.logInfo;
            }

            return logInfo;
        },

        // Redirect function
        _redirect: function (e, url, newWin) {
            if (!e) {
                var e = window.event;
            }

            try {
                e.cancelBubble = true;
            } catch (err) {

            }

            if (e.stopPropagation) {
                e.stopPropagation();
            }

            if (url) {
                if (newWin) {
                    window.open(url);
                } else {
                    setTimeout(function () { window.location.href = url; }, 500);
                }
            }
        },

        /**
         * Checks if the Google Analytics library has been downloaded yet
         * @function
         */
        isGaLoaded: function () {
            return typeof (ga) === "function" && typeof (ga.getAll) === "function";
        },

        /**
         * Handles the url event log, if GA is ready then we log the event,
         * otherwise we are going to enqueue it and wait for the pageLoad event before trying to log them
         * @function
         * @param {String} url String
         * @param {String} isGaReady String
         * @param {Boolean} areGaParamsNeeded Boolean
         * @param {Boolean} isAsync Boolean
         */
        handleLogEvent: function (url, isGaReady, areGaParamsNeeded, isAsync) {
            if (!isGaReady) {
                performanceEventsQueue.enqueueEvent(url);
            } else {
                if (areGaParamsNeeded) {
                    url = analyticsHelper.addAnalyticsUrlParameters(url);
                }
                jQuery.ajax({ type: "Post", url: url, async: isAsync });
            }
        },

        _logViewWithParameters: function (url, eventCode, parameters) {
            var wturl = url;

            if (this._fromPage == 'communityresults') {
                wturl = url;

                if (this._siteRoot == '/') {
                    wturl = "/NewHomeSource" + url;
                }
            }

            var isGaReady = this.isGaLoaded();

            var result = this.createUrl(url, parameters, isGaReady);

            var communityId = result.communityId;
            var specId = result.specId;
            var planId = result.planId;

            url = result.url;

            var async = true;
            if (typeof parameters.async != 'undefined')
                async = parameters.async;

            //GA Performance event (with enhaced ecomm)
            this._logGoogleEcommerceEvent(eventCode, communityId, specId, planId, null, parameters.builderCommunityList, parameters.homeList);

            this.handleLogEvent(url, isGaReady, false, async);
        },

        _logViewWithoutEcommerce: function (url, eventCode, parameters) {
            var wturl = url;

            if (this._fromPage == 'communityresults') {
                wturl = url;

                if (this._siteRoot == '/') {
                    wturl = "/NewHomeSource" + url;
                }
            }

            var isGaReady = this.isGaLoaded();

            var result = this.createUrl(url, parameters, isGaReady);

            url = result.url;

            var async = true;
            if (typeof parameters.async != 'undefined') {
                async = parameters.async;
            }

            this.handleLogEvent(url, isGaReady, false, async);
        },

        createUrl: function (url, parameters, isGaReady) {
            var communityId = 0, specId = 0, planId = 0;

            if (parameters.builderId) {
                url = url + "/builder-" + parameters.builderId;
            }

            if (parameters.communityId || parameters.commId) {
                url = url + "/community-" + (parameters.communityId || parameters.commId);
                communityId = (parameters.communityId || parameters.commId);
            }

            if (parameters.communityList) {
                url = url + "/communitylist-" + parameters.communityList;
            }

            if (parameters.marketId) {
                url = url + "/market-" + parameters.marketId;
            }

            if (parameters.planId) {
                url = url + "/planid-" + parameters.planId;
                planId = parameters.planId;
            }

            if (parameters.specId) {
                url = url + "/specid-" + parameters.specId;
                specId = parameters.specId;
            }

            if (isGaReady) {
                url = analyticsHelper.addAnalyticsUrlParameters(url);
            }

            if (parameters.parentCommunityId) {
                url = url + "/parentcommunityid-" + parameters.parentCommunityId;
            }

            if (parameters.basicListingId) {
                url = url + "/basiclistingid-" + parameters.basicListingId;
            }

            if (parameters.refer) {
                url = url + "/refer-" + parameters.refer;
            }

            if (parameters.totalHomes) {
                url = url + "/totalhomes-" + parameters.totalHomes;
            }

            if (parameters.builderCommunityList) {
                url = url + "?buildercommunitylist=" + parameters.builderCommunityList;
            }

            if (parameters.basicListingList) {
                url = url + "?basiclistinglist=" + parameters.basicListingList;
            }

            if (parameters.homeList) {
                url = url + "?homeList=" + parameters.homeList;
            }

            return {
                url: url,
                communityId: communityId,
                planId: planId,
                specId: specId
            }
        },

        _logView: function (url, eventCode, cid, bid, planId, specId, bsId) {
            if (url.indexOf("http://") < 0) {
                url = url.replace(' ', '').replace('//', '/');
            }

            var fromPageUrl = this._fromPage;
            var wturl = url;

            var hdPage = planId > 0 || specId > 0;

            if (cid == 0 && hdPage) {
                cid = _commIdHD;
            }

            if (bid == 0 && hdPage) {
                bid = _builderIdHD;
            }

            if (this._fromPage == 'communityresults') {
                wturl = url;
                fromPageUrl = this._siteRoot + "communityresults";

                if (this._siteRoot == '/') {
                    wturl = "/NewHomeSource" + url;
                    fromPageUrl = "/NewHomeSource/communityresults";
                }
            }

            //Log to custom via http req 
            if (bsId == 0) {
                url = url +
                    "/builder-" + bid +
                    "/community-" + cid +
                    "/planid-" + planId +
                    "/specid-" + specId +
                    "/market-" + this._marketId;
            } else {
                url = url + "/basiclistingid-" + bsId + "/market-" + this._marketId;
            }

            var isGaReady = this.isGaLoaded();
            this.handleLogEvent(url, isGaReady, true, true);

            // GA Performance event (with enhaced ecomm)
            this._logGoogleEcommerceEvent(eventCode, cid, specId, planId, null);
        },

        _logMetrics: function (event, logString) {
            var dataPost = { logsInChains: logString, eventName: event };
            jQuery.ajax({
                type: "POST",
                url: "https://" + location.host + "/metricseventlogger/",
                data: dataPost,
                dataType: "json"
            });
        },

        _logGoogleEcommerceEvent: function (eventName, communityId, specId, planId, builderName, communitiesIdsList, homesIdsList) {
            if (typeof this._performanceLogUrl == 'undefined')
                return;

            var params = {
                "eventName": eventName,
                "communityId": typeof (communityId) != 'undefined' && communityId != null ? communityId : 0,
                "specId": typeof (specId) != 'undefined' && specId != null ? specId : 0,
                "planId": typeof (planId) != 'undefined' && planId != null ? planId : 0,
                "builderName": builderName,
                "communitiesIdsList": communitiesIdsList,
                "homesIdsList": homesIdsList

            };

            var performanceLogUrl = this._performanceLogUrl;

            jQuery.ajax({
                type: "POST",
                url: performanceLogUrl,
                data: params,
                success: function (result) {
                    // The GetDataLayerPush method of the Google Analytics Controller returns a js that needs to be executed
                    eval(result);
                }
            });
        },

        googlepush: function (events, action, label, value) {
            var instance = this;
            NHS.Scripts.Helper.createCookie("CTAName", action, 1);
            if (typeof dataLayer !== "undefined") {
                dataLayer.push({
                    'event': "GAEvent",
                    'eventCategory': events,
                    'eventAction': action,
                    'eventLabel': label,
                    'eventValue': undefined
                });
            } 
        },

        /**
        * Sets a Pair to the Data Layer
        * @method
        * @param {String} key Key
        * @param {*} optValue Optional value
        */
        SetDataLayerPair: function (key, optValue) {
            try {
                var finalUrl = "/GoogleAnalytics/SetDataLayerPair";

                if (typeof (optValue) == "undefined") {
                    optValue = 0;
                }

                ajax.request({
                    type: "GET",
                    url: finalUrl,
                    data: {
                        key: key,
                        optValue: optValue
                    },
                    success: function (data) {
                        if (!(data !== "" && typeof data === "string")) return;
                        if (typeof (dataLayer) == "undefined") {
                            var tmpData = data;
                            var finalData = tmpData.replace("dataLayer", "window.parent.dataLayer");
                            eval(finalData);
                        } else {
                            eval(data);
                        }

                    }
                });
            } catch (ex) { }
        }
    }

function getValueFromObjectArray(arrayObject, propertyId) {
    var mpcValue = null;

    if (arrayObject !== null && arrayObject !== undefined) {
        mpcValue = arrayObject.map(function (obj) {
            if (obj.id === propertyId && obj.id !== "0") {
                return obj.mpcId;
            }
            return undefined;
        }).filter(function (x) { return typeof x !== 'undefined' });
    }

    return mpcValue === null || mpcValue[0] === undefined ? null : mpcValue;
}